import { ObservationType } from "@libs/gateways/clinical/ClinicalGateway.dtos.ts";
import { ClinicalRecord } from "@stores/clinical/models/ClinicalRecord.ts";
import { RootStore } from "@stores/root/RootStore.ts";

import { ClinicalToolViewDataFetcher } from "./ClinicalToolViewDataFetcher.ts";

export const getClinicalToolViewData =
  (
    clinicalRecord: ClinicalRecord,
    encounterId: string,
    observationType: ObservationType
  ) =>
  async ({ clinical }: RootStore) => {
    const clinicalToolFetcher = new ClinicalToolViewDataFetcher();
    return clinicalToolFetcher.getData({
      clinical,
      clinicalRecord,
      encounterId,
      observationType
    });
  };
